import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for hero-style headings
export const MaskLine = ({ children, delay = 0, className = "", duration = 1 }) => (
  <span className="mask-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskLineInView = ({ children, delay = 0, className = "", duration = 0.8 }) => (
  <motion.span
    className={`block ${className}`}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration, ease, delay }}
  >
    {children}
  </motion.span>
);

export const Stagger = ({ children, className = "", stagger = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 30, ...rest }) => (
  <motion.div
    className={className}
    {...rest}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease } },
    }}
  >
    {children}
  </motion.div>
);
